import { computed, action, observable } from 'mobx';
import { StoreBase } from '../../../common/StoreBase';
import { IForgotPasswordConfiguration } from '../models';
import { config } from '../../App/models/config';
import { utils } from '@kurtosys/ksys-app-template';


export class ForgotPasswordStore extends StoreBase {
	static componentKey: 'forgotPassword' = 'forgotPassword';

	@computed
	get configuration(): IForgotPasswordConfiguration | undefined {
		if (this.storeContext && this.storeContext.appStore) {
			return this.storeContext.appStore.getComponentConfiguration(ForgotPasswordStore.componentKey);
		}
	}

	@action
	async initialize(): Promise<void> {

	}

	@action
	public backToUserLogin = () => {
		const { messageStore, userLoginStore, appStore } = this.storeContext;
		messageStore.clearError();
		userLoginStore.clear();
		appStore.setStep(config.loginSteps.USER_LOGIN);
	}

	@computed
	get backButtonText(): string {
		return (this.configuration && this.configuration.backButtonText) || 'Login';
	}

	@computed
	get forgotPasswordButtonText(): string {
		return (this.configuration && this.configuration.forgotPasswordButtonText) || 'Username';
	}

	@computed
	get placeholderText(): string {
		return (this.configuration && this.configuration.placeholderText) || 'Request New Password';
	}

	@computed
	get labelText(): string | undefined {
		return this.configuration && this.configuration.labelText;
	}

	@computed
	get successMessage(): string {
		return (this.configuration && this.configuration.successMessage) ||
			'If your user exists, you should receive an email with more information, please follow the instructions listed there';
	}

	@computed
	get invalidMessage(): string {
		return (this.configuration && this.configuration.invalidMessage) ||
			'You have not provided enough information to complete this request';
	}

	@computed
	get errorMessage(): string {
		return (this.configuration && this.configuration.errorMessage) ||
			'An error occurred while processing this request. Please contact your administrator';
	}

	@action
	public updateUsername = (value: string) => {
		const { messageStore, userLoginStore } = this.storeContext;
		userLoginStore.username = value;
		messageStore.clearAll();
	}

	public onSubmitRequestPasswordReset = async () => {
		const { messageStore, userLoginStore } = this.storeContext;
		messageStore.clearAll();
		if (utils.typeChecks.isNullOrEmpty(userLoginStore.username)) {
			messageStore.setErrorText('Username is required.');
			return false;
		}
		const { appStore, kurtosysApiStore } = this.storeContext;
		const loadingKey = 'ForgotPasswordStore.onSubmitRequestPasswordReset';
		appStore.startLoading(loadingKey);
		const overrides = {
			body: {
				userName: userLoginStore.username,
			},
		};
		const response = await kurtosysApiStore.passwordReset.callApi(overrides);
		if (response.status === 200) {
			messageStore.setInfoText(this.successMessage);

		}
		else if (response.status === 400) {
			messageStore.setInfoText(this.invalidMessage);
		}
		else {
			messageStore.setErrorText(this.errorMessage);
		}
		appStore.stopLoading(loadingKey);
	}
}